<template>
  <div>
    <Toolbar class="mb-4">
      <template #left>Neue hinzufügen</template>
      <template #right>
        <Button
          icon="pi pi-times"
          class="p-button-danger"
          @click="$router.push('/admin/sections')"
        />
      </template>
    </Toolbar>
    <div class="form-card row">
      <div class="col-md-6">
        <div class="mb-3">
          <label for="name" class="form-label required">
            Name (EN)
            <span>*</span>
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="body.name.en"
            :class="{ 'is-invalid': isInvalid && !body.name.en }"
            required
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label for="name" class="form-label required">
            Name (DE)
            <span>*</span>
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="body.name.de"
            :class="{ 'is-invalid': isInvalid && !body.name.de }"
            required
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label for="slug" class="form-label required">
            Slug
            <span>*</span>
          </label>
          <input
            type="tel"
            class="form-control"
            id="slug"
            v-model="body.slug"
            :class="{ 'is-invalid': isInvalid && !body.slug }"
            required
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-5">
          <label for="Image" class="form-label required">
            Image
            <span>*</span>
          </label>
          <img
            :src="body.image"
            v-if="id"
            class="profile-pic height-150 width-150 align-items-center"
            style="width: 100px; height: 100px"
          />
          <div class="position-relative">
            <i class="ri-pencil-line upload-button"></i>
            <b-form-file
              class="h-100 position-absolute"
              accept="image/*"
              @change="previewImage"
            ></b-form-file>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="parntId" class="form-label required"> Main </label>

          <select
            class="form-select form-control"
            id="parntId"
            name="parntId"
            v-model.number="body.parntId"
            :class="{ 'is-invalid': isInvalid && !body.parntId }"
            required
          >
            <option v-for="i in catList" :key="i.id" :value="i.id">
              {{ JSON.parse(i.name).de }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="inhomepage" class="form-label required">
            Main Section
          </label>

          <SelectButton
            v-model="body.cattype"
            :options="optionsList"
            optionValue="value"
            optionLabel="name"
          />
        </div>
      </div>

      <div class="col-md-12">
        <div class="mb-3 text-center">
          <Button
            label="Bearbeiten"
            icon="pi pi-pencil"
            class="ml-2 p-button-info"
            @click="update()"
            v-if="id"
            :disabled="disabledAdd"
          />
          <Button
            v-else
            label="Hinzufügen"
            icon="pi pi-plus"
            class="ml-2 p-button-success"
            @click="save()"
            :disabled="disabledAdd"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const d = new Date();
    const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
    const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(d);
    const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
    return {
      minDateValue: new Date(`${ye}-${mo}-${da}`),
      body: {
        name: { en: null, de: null },

        slug: null,
        image: null,
        cattype: 0,
        parntId: null,
      },
      id: null,

      isInvalid: false,
      disabledAdd: false,
      catList: [],
      optionsList: [
        { name: "Main", value: 0 },
        { name: "Sub", value: 1 },
      ],
    };
  },
  methods: {
    previewImage(ev) {
      this.$file2base64(ev, (image) => {
        this.body.image = image;
      });
    },

    save() {
      if (this.body.image && this.body.name.en && this.body.name.de) {
        this.disabledAdd = true;
        this.$http.post(`sections`, this.body).then(
          () => {
            this.$toast.add({
              severity: "success",
              summary: "Done Successfully",
              detail: "Added Successfully",
              life: 3000,
            });
            this.disabledAdd = false;

            this.$router.push("/admin/sections");
          },
          (err) => {
            this.disabledAdd = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.response.data.message,
              life: 3000,
            });
          }
        );
      } else {
        this.isInvalid = true;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please add the required fields",
          life: 3000,
        });
      }
    },
    update() {
      if (this.body.name.en && this.body.name.de) {
        this.disabledAdd = true;

        if (this.body.image.startsWith("http")) {
          delete this.body.image;
        }

        this.$http.put(`sections/${this.id}`, this.body).then(
          () => {
            this.$toast.add({
              severity: "success",
              summary: "Done Successfully",
              detail: "Updated Successfully",
              life: 3000,
            });
            this.disabledAdd = false;

            this.$router.push("/admin/sections");
          },
          (err) => {
            this.disabledAdd = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.response.data.message,
              life: 3000,
            });
          }
        );
      } else {
        this.isInvalid = true;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please add the required fields",
          life: 3000,
        });
      }
    },
  },
  created() {
    this.$http.get(`sections`).then((res) => {
      this.catList = res.data.data;
    });
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.$http.get(`sections/${this.id}`).then(
        (res) => {
          this.body = res.data.data;

          this.body.image = this.$baseUploadURL + this.body.image;

          this.body.name = JSON.parse(this.body.name);
        },
        (err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );
    }
  },
};
</script>
